import {Button, Form, Table} from "antd";
import '../../assets/css/Dentobook.css';
import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import UserIcon from "../common/UserIcon";
import dayjs from 'dayjs';
import {DentobookApplicationContext} from "../../context/DentobookApplicationContext";
import {Patient, StatusResponse} from "../../api-client";
import ExcuseNoteModal from "./ExcuseNoteModal";
import {getPatientApi, getMedicalStaffApi, getStatusesApi} from "../../api/apiInstances";
import logger from "../../utils/logger";

const ExcuseNotes: React.FC = () => {
    const [patients, setPatients] = useState<any[]>([]);
    const [selectedPatient, setSelectedPatient] = useState<Patient | undefined>(undefined);
    const [statuses, setStatuses] = useState<StatusResponse[]>([]);
    const {locale} = React.useContext(DentobookApplicationContext);
    dayjs.locale(locale);

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const patientApi = getPatientApi();
    const medicalApi = getMedicalStaffApi();
    const statusesApi = getStatusesApi();

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        patientApi.fetchPatientsWithSentNzisData()
            .then((response) => {
                if (typeof response.data === 'undefined') {
                    return;
                }

                setPatients(response.data);

                statusesApi.fetchAllStatuses()
                    .then(res => {
                        setStatuses(res.data);
                    })
                    .catch(err => logger.log(err));
            })
            .catch(err => logger.log(err));
    }

    const openExcuseNoteModal = (patient: Patient) => {
        setSelectedPatient(patient);
        setIsModalOpen(true);
    };

    return (
        <>
            {selectedPatient && (
                <ExcuseNoteModal isModalOpen={isModalOpen}
                                 setIsModalOpen={setIsModalOpen}
                                 statuses={statuses}
                                 patient={selectedPatient}
                />
            )}
            <div style={{paddingTop: '10px'}}>
                <Form.Item
                    className={"dentobook-form-item"}
                    rules={[{required: true, message: <FormattedMessage id="required_field"/>}]}
                >
                </Form.Item>
                <Table dataSource={patients}
                       pagination={false}
                       style={{paddingTop: '10px'}}
                       className="dentobook-table">
                    <Table.Column key="id" width="25%" render={(patient) => {
                        // Use presigned R2 URL from API response
                        const avatarSrc = patient.avatarUrl;
                        return (
                            <div className="username-icon">
                                {!avatarSrc ? <UserIcon size="small"/> :
                                    <img className="thumbnail-img"
                                         width={10}
                                         src={avatarSrc}
                                         alt="avatar"/>
                                }
                                <span className="font-weight-500">{patient.firstName + ' ' + patient.lastName}</span>
                            </div>
                        );
                    }}
                                  title={<FormattedMessage id="name"/>}
                                  sorter={{}}
                    />
                    <Table.Column key="egn" width="15%" title="ЕГН"
                                  sorter={{}}
                                  render={patient => <span
                                      className="font-weight-500">{patient.egn}</span>}
                    />
                    <Table.Column key="phone"
                                  width="55%"
                                  render={patient => <span className="font-weight-500">{patient.phone}</span>}
                                  title={<FormattedMessage id="phone"/>}/>
                    <Table.Column key="excuseNoteButton"
                                  width="5%"
                                  render={patient => <Button type="link"
                                                        onClick={() => openExcuseNoteModal(patient)}
                                                        className="font-weight-500 font-family-roboto font-16"><FormattedMessage
                                      id="create_note"/></Button>}
                                  title={<div></div>}/>

                </Table>
            </div>
        </>
    );
};

export default ExcuseNotes;